import { createIcon } from '@chakra-ui/icons';

export const DropdownSimple = createIcon({
  displayName: 'DropdownSimple',
  viewBox: '0 0 19 18',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <rect
        x="1.19231"
        y="5.82366"
        width="16.6154"
        height="6.35304"
        rx="3.17652"
        stroke="currentColor"
        strokeWidth="1.38462"
      />
      <path
        d="M15.2755 7.90747C15.2586 7.87503 15.2332 7.84785 15.2019 7.82887C15.1706 7.80989 15.1348 7.79984 15.0982 7.7998H12.2966C12.26 7.79984 12.2241 7.80991 12.1928 7.82892C12.1616 7.84793 12.1361 7.87516 12.1192 7.90764C12.1023 7.94012 12.0947 7.9766 12.0971 8.01313C12.0995 8.04965 12.1119 8.08481 12.1329 8.11478L13.5337 10.1159C13.5522 10.1422 13.5767 10.1636 13.6052 10.1784C13.6337 10.1932 13.6653 10.2009 13.6974 10.2009C13.7295 10.2009 13.7611 10.1932 13.7896 10.1784C13.8181 10.1636 13.8426 10.1422 13.8611 10.1159L15.2619 8.11478C15.2829 8.08478 15.2953 8.04959 15.2977 8.01303C15.3001 7.97647 15.2924 7.93996 15.2755 7.90747Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
